import React, { useState } from 'react';
import LocalAuthorityItem from './LocalAuthorityItem';

const LocalAuthoritiesSection = () => {
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const ITEMS_PER_PAGE = 10;

    const localAuthorities = [
        { name: 'Local Authority 1', status: 'active' },
        { name: 'Local Authority 2', status: 'inactive' },
        { name: 'Local Authority 3', status: 'active' },
        { name: 'Local Authority 4', status: 'inactive' },
        { name: 'Local Authority 5', status: 'active' },
        { name: 'Local Authority 6', status: 'inactive' },
        { name: 'Local Authority 1', status: 'active' },
        { name: 'Local Authority 2', status: 'inactive' },
        { name: 'Local Authority 3', status: 'active' },
        { name: 'Local Authority 4', status: 'inactive' },
        { name: 'Local Authority 5', status: 'active' },
        { name: 'Local Authority 6', status: 'inactive' },
        // Add more local authorities as needed...
    ];

    const filteredAuthorities = localAuthorities.filter(authority =>
        authority.name.toLowerCase().includes(search.toLowerCase())
    );

    // Pagination logic
    const totalPages = Math.ceil(filteredAuthorities.length / ITEMS_PER_PAGE);
    const paginatedAuthorities = filteredAuthorities.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
    );

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
        setCurrentPage(1); // Reset to page 1 after search
    };

    const handlePageChange = (direction) => {
        if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        } else if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const styles = {
        paginationContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '20px',
            paddingBottom: '30px', // Add padding to prevent touching the border
        },
        paginationButton: {
            margin: '0 10px',
            padding: '10px 20px',
            cursor: 'pointer',
            border: '1px solid rgba(0, 0, 0, 0.2)',
            borderRadius: '5px',
            backgroundColor: '#e0e0e0', // Light gray background for inactive state
            color: '#333',
            fontSize: '16px',
            transition: 'background-color 0.2s ease, color 0.2s ease',
            outline: 'none',
            boxShadow: 'none', // Remove focus border shadow
        },
        disabledButton: {
            backgroundColor: 'white',
            opacity: 0.5,
            cursor: 'not-allowed',
        },
        activeButton: {
            backgroundColor: '#b0b0b0', // Slightly darker gray for active state
            color: '#fff',
        },
        paginationPage: {
            margin: '0 10px',
            padding: '10px 15px',
            fontSize: '16px',
            color: '#333',
        },
        noItemsMessage: {
            fontSize: '18px',
            color: '#333',
            textAlign: 'center',
            width: '100%', // Full width of the container
            padding: '15px',
            backgroundColor: '#f8f9fa', // Light background
            borderRadius: '8px',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)', // Subtle shadow
            marginTop: '20px', // Spacing from the top
        },
    };

    return (
        <div className="card">
            <div className="header">
                <h2><strong>Local Authorities</strong></h2>
                <div className="org-section-search-bar">
                    <input 
                        type="text" 
                        placeholder="Search for local authorities..." 
                        value={search} 
                        onChange={handleSearchChange} 
                        className="form-control" 
                    />
                </div>
            </div>
            <div className="body">
                <ul className="list-unstyled">
                    {paginatedAuthorities.map((authority, index) => (
                        <LocalAuthorityItem key={index} name={authority.name} status={authority.status} />
                    ))}
                </ul>
                {filteredAuthorities.length === 0 && <p style={styles.noItemsMessage}>No local authorities found.</p>}
            </div>
            {/* Pagination controls */}
            {totalPages > 1 && (
                <div style={styles.paginationContainer}>
                    <button 
                        style={{ 
                            ...styles.paginationButton, 
                            ...(currentPage === 1 ? styles.disabledButton : styles.activeButton),
                        }}
                        onClick={() => handlePageChange('prev')}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    <span style={styles.paginationPage}>{currentPage} / {totalPages}</span>
                    <button 
                        style={{ 
                            ...styles.paginationButton, 
                            ...(currentPage === totalPages ? styles.disabledButton : styles.activeButton),
                        }}
                        onClick={() => handlePageChange('next')}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            )}
        </div>
    );
};

export default LocalAuthoritiesSection;
